import * as T from '../../constants/boost';

const initialState = {
  messages: [],
  detail: null,
  // Home history accordion, paged per status bucket:
  //   { [group]: { rows, total, offset, hasMore, loading, loaded } }
  // Holds only the pages actually fetched - never the whole history.
  historyPages: {},
  sending: false,
  sendResult: null,
  costEstimate: null,
  estimating: false,
  customers: [],
  templates: [],
  credit: null,
  settings: null,
  admin: null,
  analytics: null,
  platformConfig: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case T.STORE_BOOST_HISTORY:
      // A fresh full-history load (first paint, or after a send/retry)
      // invalidates every bucket page - membership AND counts can both
      // have moved, so the accordion refetches from page 1 on next open.
      return {
        ...state,
        messages: action.messages || [],
        historyPages: {},
      };
    case T.STORE_BOOST_DETAIL:
      return { ...state, detail: action.detail || null };
    case T.STORE_BOOST_SENDING:
      return { ...state, sending: !!action.sending };
    case T.STORE_BOOST_SEND_RESULT:
      return { ...state, sendResult: action.result || null };
    case T.STORE_BOOST_COST_ESTIMATE:
      return { ...state, costEstimate: action.estimate || null };
    case T.STORE_BOOST_ESTIMATING:
      return { ...state, estimating: !!action.estimating };
    case T.CLEAR_BOOST_COST_ESTIMATE:
      return { ...state, costEstimate: null, estimating: false };
    case T.CLEAR_BOOST_DETAIL:
      return { ...state, detail: null };
    case T.STORE_BOOST_HISTORY_PAGE: {
      const p = action.payload || {};
      if (!p.group) return state;
      const prev = state.historyPages[p.group] || { rows: [] };
      return {
        ...state,
        historyPages: {
          ...state.historyPages,
          [p.group]: {
            rows: p.append
              ? [...prev.rows, ...(p.rows || [])]
              : p.rows || [],
            total: p.total || 0,
            offset: p.offset || 0,
            hasMore: !!p.hasMore,
            loading: false,
            loaded: true,
          },
        },
      };
    }
    case T.STORE_BOOST_HISTORY_PAGE_LOADING: {
      if (!action.group) return state;
      const prev = state.historyPages[action.group] || {
        rows: [],
        loaded: false,
      };
      return {
        ...state,
        historyPages: {
          ...state.historyPages,
          [action.group]: { ...prev, loading: !!action.loading },
        },
      };
    }
    case T.STORE_BOOST_CUSTOMERS:
      return { ...state, customers: action.customers || [] };
    case T.STORE_BOOST_TEMPLATES:
      return { ...state, templates: action.templates || [] };
    case T.STORE_BOOST_CREDIT:
      return { ...state, credit: action.credit || null };
    case T.STORE_BOOST_SETTINGS:
      return { ...state, settings: action.settings || null };
    case T.STORE_BOOST_ADMIN:
      return { ...state, admin: action.admin || null };
    case T.STORE_BOOST_ANALYTICS:
      return { ...state, analytics: action.analytics || null };
    case T.STORE_BOOST_PLATFORM_CONFIG:
      return { ...state, platformConfig: action.platformConfig || null };
    default:
      return state;
  }
};
